import { c as _c } from "react/compiler-runtime";
import { NoResult } from "@website/accommodation-ui/tour-search-wrapper-group/tour-search-panel/auto-complete-input/no-search-result";
import { useQueryCities } from "@website/accommodation-ui/tour-search-wrapper-group/tour-search-panel/auto-complete-input/queries";
import { CityType, OnChangeItemType } from "@website/accommodation-ui/tour-search-wrapper-group/tour-search-panel/auto-complete-input/types";
import { useDebounce } from "@website/hooks/debounce";
import { Origin } from "@website/icons/components/origin";
import { useRouter } from "next/router";
import { useState } from "react";
const useAutoComplete = (type, defaultValue, onChangeItem, suggestions) => {
  const $ = _c(31);
  const [query, setQuery] = useState("");
  const isHomePage = process.env.NEXT_PUBLIC_APP_NAME === "homepage";
  const router = useRouter();
  const [selectedItem, setSelectedtem] = useState(null);
  const debouncedQuery = useDebounce(query, 250);
  const {
    data: cities,
    isLoading: isLoadingCities
  } = useQueryCities(debouncedQuery);
  let t0;
  if ($[0] !== cities?.items || $[1] !== debouncedQuery.length || $[2] !== suggestions) {
    t0 = debouncedQuery.length >= 2 ? cities?.items || [] : suggestions || [];
    $[0] = cities?.items;
    $[1] = debouncedQuery.length;
    $[2] = suggestions;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const list = t0;
  let t1;
  if ($[4] !== suggestions) {
    t1 = suggestions || [];
    $[4] = suggestions;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const tags = t1;
  let t2;
  if ($[6] !== list) {
    t2 = Array.isArray(list) ? list?.map(_temp) : [];
    $[6] = list;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const listNormalized = t2;
  let t3;
  if ($[8] !== type) {
    t3 = value => {
      type === "dest" && setQuery(value);
    };
    $[8] = type;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const onChangeQuery = t3;
  let t4;
  if ($[10] !== list || $[11] !== onChangeItem) {
    t4 = id => {
      const originItem = list?.find(origin => `${origin?.id}` === `${id}`);
      setQuery("");
      setSelectedtem(originItem);
      onChangeItem(originItem);
    };
    $[10] = list;
    $[11] = onChangeItem;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const onSelectItem = t4;
  let t5;
  if ($[13] !== router || $[14] !== tags) {
    t5 = id_0 => {
      const originItem_0 = tags?.find(origin_0 => `${origin_0?.id}` === `${id_0}`);
      router.push({
        pathname: isHomePage ? "/tour/group" : "/group",
        query: {
          type: originItem_0?.type,
          dest_id: originItem_0?.id
        }
      });
    };
    $[13] = router;
    $[14] = tags;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const onSelectTag = t5;
  const noResult = query?.length >= 2 && !isLoadingCities && list && list?.length === 0;
  const t6 = selectedItem?.title || defaultValue || "";
  let t7;
  if ($[16] !== noResult || $[17] !== query) {
    t7 = noResult ? <NoResult query={query} /> : undefined;
    $[16] = noResult;
    $[17] = query;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== isLoadingCities || $[20] !== list || $[21] !== listNormalized || $[22] !== onChangeQuery || $[23] !== onSelectItem || $[24] !== onSelectTag || $[25] !== query || $[26] !== selectedItem || $[27] !== t6 || $[28] !== t7 || $[29] !== tags) {
    t8 = {
      list,
      loading: isLoadingCities,
      listNormalized,
      onSelect: onSelectItem,
      onChangeQuery,
      selectedItem,
      selectedText: t6,
      query,
      NoResult: t7,
      tags,
      onSelectTag
    };
    $[19] = isLoadingCities;
    $[20] = list;
    $[21] = listNormalized;
    $[22] = onChangeQuery;
    $[23] = onSelectItem;
    $[24] = onSelectTag;
    $[25] = query;
    $[26] = selectedItem;
    $[27] = t6;
    $[28] = t7;
    $[29] = tags;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  return t8;
};
export const useOrigin = (defaultValue, onChangeItem, originSuggestions) => {
  const $ = _c(12);
  const result = useAutoComplete("origin", defaultValue, onChangeItem, originSuggestions);
  let t0;
  if ($[0] !== result.listNormalized) {
    t0 = result.listNormalized || [];
    $[0] = result.listNormalized;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== result.NoResult || $[3] !== result.list || $[4] !== result.loading || $[5] !== result.onChangeQuery || $[6] !== result.onSelect || $[7] !== result.query || $[8] !== result.selectedItem || $[9] !== result.selectedText || $[10] !== t0) {
    t1 = {
      originList: result.list,
      originLoading: result.loading,
      originListNormalized: t0,
      onSelectOrigin: result.onSelect,
      onChangeOriginQuery: result.onChangeQuery,
      selectedOriginItem: result.selectedItem,
      selectedOriginText: result.selectedText,
      originQuery: result.query,
      OriginNoResult: result.NoResult,
      originLabel: "\u0634\u0647\u0631 \u0645\u0628\u062F\u0627"
    };
    $[2] = result.NoResult;
    $[3] = result.list;
    $[4] = result.loading;
    $[5] = result.onChangeQuery;
    $[6] = result.onSelect;
    $[7] = result.query;
    $[8] = result.selectedItem;
    $[9] = result.selectedText;
    $[10] = t0;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  return t1;
};
export const useDestination = (defaultValue, onChangeItem, destinationSuggestions) => {
  const $ = _c(14);
  const result = useAutoComplete("dest", defaultValue, onChangeItem, destinationSuggestions);
  let t0;
  if ($[0] !== result.listNormalized) {
    t0 = result.listNormalized || [];
    $[0] = result.listNormalized;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = result?.tags;
  let t2;
  if ($[2] !== result.NoResult || $[3] !== result.list || $[4] !== result.loading || $[5] !== result.onChangeQuery || $[6] !== result.onSelect || $[7] !== result.onSelectTag || $[8] !== result.query || $[9] !== result.selectedItem || $[10] !== result.selectedText || $[11] !== t0 || $[12] !== t1) {
    t2 = {
      destinationList: result.list,
      destinationLoading: result.loading,
      destinationListNormalized: t0,
      onSelectDestination: result.onSelect,
      onChangeDestinationQuery: result.onChangeQuery,
      selectedDestinationItem: result.selectedItem,
      selectedDestinationText: result.selectedText,
      destinationQuery: result.query,
      DestinationNoResult: result.NoResult,
      destinationLabel: "\u0645\u0642\u0635\u062F",
      destinationPlaceHolder: "\u0645\u0642\u0635\u062F (\u0634\u0647\u0631\u060C \u06A9\u0634\u0648\u0631\u060C \u0642\u0627\u0631\u0647)",
      destinationTags: t1,
      destinationOnSelectTag: result.onSelectTag
    };
    $[2] = result.NoResult;
    $[3] = result.list;
    $[4] = result.loading;
    $[5] = result.onChangeQuery;
    $[6] = result.onSelect;
    $[7] = result.onSelectTag;
    $[8] = result.query;
    $[9] = result.selectedItem;
    $[10] = result.selectedText;
    $[11] = t0;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
};
function _temp(item) {
  return {
    id: item?.id,
    title: item?.title,
    type: item?.type,
    StartIcon: <Origin />
  };
}